import React, {useEffect, useState} from "react";
import { Dialog, DialogTitle, Button, ToggleButtonGroup, ToggleButton, TextField } from "@mui/material";
import ToggleSwitch from "../../../components/ToggleSwitch/ToggleSwitch";
import {FormattedMessage} from "react-intl";
import Typography from "@mui/material/Typography";
import PaySafe from "./PaySafe/PaySafe";
import Nuvei from "./Nuvei/Nuvei";
import GlobalConst from "../../../constants/GlobalConst";
import {useNavigate} from "react-router-dom";
import "./SecureDepositPopUp.style.scss";
import Skrill from "./Skrill/Skrill";

const SecureDepositPopUp = ({id, title, subTitle, open, onClose, onCancel, onOk, options, data}) => {

    const commonProps = {
        showCloseBtn: true,
        onClose,
        parlayContext: data,
    };

    return (
        <Dialog open={open}
                onClose={onClose}
                className="SecureDepositPopUp"
                sx={{
                    '& .MuiPaper-root': {
                       maxHeight: window.screen.height - 150,
                    },
                }}
        >
            <div className={"closeButton"}
                 onClick={onClose}>X</div>
            <div className="content">
                {{
                    ".com": () => <PaySafe {...commonProps} />,
                    ".mx": () => <Skrill {...commonProps} />,
                    ".fr": ()=>null
                }[GlobalConst.SITE_TLD]()}
            </div>
        </Dialog>
    );
};

export default SecureDepositPopUp;
